export const PAGINATION = "x-pagination";
export const SUGGESTEDFILENAME = "x-suggested-filename";